import { privateInstance } from "../configs";
import { mappers } from "@/mappers";

export const recipeApi = {
  // Recipes
  async getRecipes() {
    let url = `/recipes/api/list/`;
    const res = await privateInstance.get(url);
    return res.data.map(r => mappers.mapRecipe(r));
  },
  async postRecipe(recipe) {
    const res = await privateInstance.post(`/recipes/api/list/`, recipe);
    return mappers.mapRecipe(res.data);
  },
  async retrieveRecipe(id) {
    const res = await privateInstance.get(`/recipes/api/${id}/`);
    return mappers.mapRecipe(res.data);
  },
  async putRecipe(id, recipe) {
    const res = await privateInstance.put(`/recipes/api/${id}/`, recipe);
    return mappers.mapRecipe(res.data);
  },
  async patchRecipe(id, recipe) {
    const res = await privateInstance.patch(`/recipes/api/${id}/`, recipe);
    return res.data;
  },
  async patchSimpleRecipe(id, recipe) {
    const res = await privateInstance.patch(
      `/recipes/api/update/${id}/`,
      recipe
    );
    return res.data;
  },
  async patchRecipeTags(id, data) {
    const res = await privateInstance.patch(
      `/recipes/api/tags/update/${id}/`,
      data
    );
    return res.data;
  },
  async deleteRecipe(id) {
    const res = await privateInstance.delete(`/recipes/api/${id}/`);
    return mappers.mapRecipe(res.data);
  },
  // Ingredients
  async getRecipeIngredients() {
    let url = `/recipes/api/ingredient/list/`;
    const res = await privateInstance.get(url);
    return res.data;
  },
  async postRecipeIngredient(ingredient) {
    const res = await privateInstance.post(
      `/recipes/api/ingredient/create/`,
      ingredient
    );
    return res.data;
  },
  async patchRecipeIngredient(recipeId, id, ingredient) {
    const res = await privateInstance.patch(
      `/recipes/api/ingredient/${recipeId}/${id}/`,
      ingredient
    );
    return res.data;
  },
  async putRecipeIngredient(recipeId, id, ingredient) {
    const res = await privateInstance.put(
      `/recipes/api/ingredient/${recipeId}/${id}/`,
      ingredient
    );
    return res.data;
  },
  async deleteRecipeIngredient(recipeId, id) {
    const res = await privateInstance.delete(
      `/recipes/api/ingredient/${recipeId}/${id}/`
    );
    return res.data;
  },
  async copyRecipe(data) {
    const res = await privateInstance.post(`/recipes/api/copy/`, data);
    return res.data;
  },
  async importRecipeStoreData(params) {
    let req = `/recipes/api/import-data/`;

    if (params) {
      req += "?";
      let params_array = [];
      if (params.store) params_array.push(`store=${params.store}`);
      if (params.recipe) params_array.push(`recipe=${params.recipe}`);
      req += params_array.join("&");
    }

    const res = await privateInstance.get(req);
    return res.data;
  },
  async overwriteRecipeStoreData(params) {
    let req = `/recipes/api/debug/recipe/overwrite/`;

    if (params) {
      req += "?";
      let params_array = [];
      if (params.store) params_array.push(`store=${params.store}`);
      req += params_array.join("&");
    }

    const res = await privateInstance.get(req);
    return res.data;
  }
};
